<template>
  <!-- zd-box 管理-->
  <div class="list-container">
    <div class="list-bread-crumb-div">
      <ZD-bread-crumb :bConfigList="pageConfig.listBreadCrumb"></ZD-bread-crumb>
    </div>
    <div class="list-content-div">
      <div class="list-header-title-div">zd-box管理</div>
      <ZD-list-querys>
        <template slot="inputs">
          <div class="list-query-child-div flex">
            <div class="query-title-div">ZD-BOX编号</div>
            <div class="query-inputs-div flex-1">
              <el-input size="small" v-model="queryInfo.snCode" placeholder="请输入ZD-BOX编号" clearable/>
            </div>
          </div>
          <div class="list-query-child-div flex">
            <div class="query-title-div" style="width: 120px">型 号</div>
            <div class="query-inputs-div flex-1">
              <el-select class="full-width" size="small" v-model="queryInfo.typeId" @change="stationNameChange" clearable filterable no-data-text="暂无数据">
                <el-option v-for="item in deviceArr" :key="item.typeId" :label="item.typeName" :value="item.typeId" />
              </el-select>
            </div>
          </div>
        </template>
        <template slot="inputs">
          <div class="list-query-child-div flex">
            <div class="query-title-div">所属站点</div>
            <div class="query-inputs-div flex-1">
              <el-select class="full-width" size="small" v-model="queryInfo.stationId" @change="stationNameChange" clearable filterable no-data-text="暂无数据">
                <el-option v-for="item in siteArr" :key="item.stationNo" :label="item.stationName" :value="item.stationName" />
              </el-select>
            </div>
          </div>
        </template>
        <template slot="actions">
          <button class="common-bg-button" @click="getListData(pagination, true)">搜 索</button>
          <button class="common-empty-button" @click="reset()">重 置</button>
        </template>
      </ZD-list-querys>
      <div class="page-action-btns">
        <button class="common-bg-button" @click="listEditFun()" v-if="$S.checkUserMenu('pileStationEdit')">编 辑</button>
      </div>
      <!-- 表格 -->
      <div class="list-table">
        <ZD-table
          :tableColumns="pageConfig.listColumns"
          :operates="operates"
          :tableData="tableData"
          :tableConfig="pageConfig.tableConfig"
          :selections="selections"
          v-on:updateSelections="(sels) => { selections = sels }"
        />
      </div>
      <!-- 分页 -->
      <div class="list-pagination">
        <ZD-pagination :pagination="pagination" v-on:pageUpdate="getListData" />
      </div>
    </div>
  </div>
</template>

<script>
  import pageConfig from "./page-config";

  export default {
    data() {
      return {
        pageConfig: pageConfig, // 页面配置
        pagination: pageConfig.pagination,
        tableData: [], // 表格数据
        siteArr:[],
        deviceArr:[],
        stationName:'',
        queryInfo: {
          snCode: "",
          stationId: "",
          typeId: '',
        },
        selections: [],
        // 列操作按钮
        operates: {
          width: 220,
          fixed: "right",
          list: [
            {
              id: "record",
              label: "充放电记录",
              type: "primary",
              show: true,
              disabled: false,
              auth: true,
              authName: "",
              method: (index, row) => {
                this.$router.push({
                  name: 'energyStorage'
                })
              }
            },
          ],
        },
      };
    },
    mounted() {
      this.getSite()
      this.getListData(this.pagination, true);
    },
    methods: {
      // 数据初始化
      getListData(pagination, reload = false) {
        let _ = this;
        if(_.stationName === '全部电站'){
          _.queryInfo.stationName = ''
        }
        _.$U.showLoading(_);
        _.queryInfo.pageNum = pagination.current - 1;
        if (reload) {
          pagination.current = 1;
          _.queryInfo.pageNum = 0;
        }
        _.queryInfo.pageSize = pagination.pageSize;
        _.$H.post(_, _.$A.pilestation.getDeviceList, _.queryInfo).then((res) => {
          _.tableData = res.data.data.content || [];
          _.pagination.total = res.data.data.totalElements || 0;
          _.$U.hideLoading(_);
        });
      },

      stationNameChange(val){
        this.queryInfo.stationName = val
      },
      getSite() {
        let _ = this;
        _.$H.post(_, _.$A.pileStation.listStationByDeal, {}).then((res) => {
          _.siteArr = res.data.data || [];
        });
        _.$H.get(_, _.$A.pilestation.getDeviceType, {}).then(res => {
          _.deviceArr = res.data.data || [];
        })
      },

      // 编辑
      listEditFun() {
        this.$S.tableEditFun(this, this.selections, pageConfig.tableEditObj);
      },

      // 重置
      reset() {
        let _ = this;
        this.pagination.current = 1;
        _.queryInfo = {
          stationName: "",
          elecName: "",
          yearMon: "",
        };
        _.getListData(_.pagination, true);
      },
    },
  };
</script>

<style lang="less" scoped></style>
